module.exports = __webpack_public_path__ + "img/fig9.24.84065741.png";